import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Modal from 'components/shared/modal';
import communityIcon from 'assets/img/landing/landing-icon-community.svg';
import lessonIcon from 'assets/img/landing/landing-icon-lesson.svg';
import studentIcon from 'assets/img/landing/landing-icon-skills.svg';
import dataIcon from 'assets/img/landing/landing-icon-data.svg';
import championsIcon from 'assets/img/landing/landing-icon-champions.svg';
import styles from './styles.module.scss';

const AudienceSegmentModal = ({ onClose, onSelectEducatorInfoURL, onSelectEducatorSolutionsURL, onSelectParentInfoURL, onSelectParentSolutionsURL, onContact }) =>  {
  const [selected, setSelected] = useState('');
  return (
    <Modal
      heading={selected === 'parent' ?
        (<span>I am a <strong>Parent</strong> looking for...</span>)
        : selected === 'educator' ?
          (<span>I am an <strong>Educator</strong> looking for ...</span>)
          : (<span><strong>Select</strong> which one best describes you</span>)}
      onCancel={onClose}
      size="lg"
      centered
      headerTag="h4"
      buttonClass="font-heavy"
      noFooter
      bodyClass={styles.audienceSegmentModal}
    >
      {selected === '' && (
        <div className="row equal-height">
          <div className="col-12 col-sm-6">
            <button onClick={() => setSelected('parent')}>
              <div className={styles.audienceCard}>
                <img
                  alt="illustration of faces of parent with two children in front of Unyted-connected devices (laptop, phone, tablet)"
                  src={lessonIcon}
                  style={{ maxWidth: '100%', height: '100px', width: 'auto', margin: '0 auto' }}
                  className="rounded"
                />
                <h4 className="font-heavy text-center mt-3">Parent</h4>
                <span className="text-gray text-center font-heavy">Unlock key methods so your child thrives.</span>
              </div>
            </button>
          </div>
          <div className="col-12 col-sm-6">
            <button onClick={() => setSelected('educator')}>
              <div className={styles.audienceCard}>
                <img
                  alt="illustration of school community with adults, children, a school building, and a green tree"
                  src={communityIcon}
                  style={{ maxWidth: '100%', height: '100px', width: 'auto', margin: '0 auto' }}
                  className="rounded"
                />
                <h4 className="font-heavy text-center mt-3">School Educator</h4>
                <span className="text-gray text-center font-heavy">How to save time and get better results.</span>
              </div>
            </button>
          </div>
          <div className="col-12 col-sm-6">
            <button onClick={onContact}>
              <div className={styles.audienceCard}>
                <img
                  alt="illustration of person reviewing progress on Unyted and discovering gaps in understanding"
                  src={dataIcon}
                  style={{ maxWidth: '100%', height: '100px', width: 'auto', margin: '0 auto' }}
                  className="rounded"
                />
                <h4 className="font-heavy text-center mt-3">Corporate Educator</h4>
                <span className="text-gray text-center font-heavy">Improve engagement and retention.</span>
              </div>
            </button>
          </div>
          <div className="col-12 col-sm-6">
            <button onClick={onContact}>
              <div className={styles.audienceCard}>
                <img
                  alt="illustration of student surrounded by geometric shapes representing the distinct skills that Unyted develops"
                  src={studentIcon}
                  style={{ maxWidth: '235px', height: '100px', width: 'auto', margin: '0 auto' }}
                  className="rounded"
                />
                <h4 className="font-heavy text-center mt-3">Learner</h4>
                <span className="text-gray text-center font-heavy">Request Unyted at your school!</span>
              </div>
            </button>
          </div>
        </div>
      )}
      {selected === 'parent' && (
        <div className="row equal-height">
          <div className="col-12 col-sm-6">
            <Link role="button" to={onSelectParentInfoURL} className="pointer">
              <div className={styles.audienceCard}>
                <img
                  alt="illustration of faces of parent with two children in front of Unyted-connected devices (laptop, phone, tablet)"
                  src={lessonIcon}
                  style={{ maxWidth: '100%', height: '100px', width: 'auto', margin: '0 auto' }}
                  className="rounded"
                />
                <h4 className="font-heavy text-center mt-3">Information</h4>
                <span className="text-gray text-center font-heavy">Learn what makes the Unyted Method &amp; Platform different</span>
              </div>
            </Link>
          </div>
          <div className="col-12 col-sm-6">
            <Link role="button" to={onSelectParentSolutionsURL} className="pointer">
              <div className={styles.audienceCard}>
                <img
                  alt="illustration of people coaching and cheering for improved engagement"
                  src={championsIcon}
                  style={{ maxWidth: '100%', height: '100px', width: 'auto', margin: '0 auto' }}
                  className="rounded"
                />
                <h4 className="font-heavy text-center mt-3">Solutions</h4>
                <span className="text-gray text-center font-heavy">Find a personalized coach to empower your child</span>
              </div>
            </Link>
          </div>
        </div>
      )}
      {selected === 'educator' && (
        <div className="row equal-height">
          <div className="col-12 col-sm-6">
            <Link role="button" to={onSelectEducatorInfoURL} className="pointer">
              <div className={styles.audienceCard}>
                <img
                  alt="illustration of person reviewing progress on Unyted and discovering gaps in understanding"
                  src={dataIcon}
                  style={{ maxWidth: '100%', height: '100px', width: 'auto', margin: '0 auto' }}
                  className="rounded"
                />
                <h4 className="font-heavy text-center mt-3">Information</h4>
                <span className="text-gray text-center font-heavy">Learn what makes the Unyted Method &amp; Platform different</span>
              </div>
            </Link>
          </div>
          <div className="col-12 col-sm-6">
            <Link role="button" to={onSelectEducatorSolutionsURL} className="pointer">
              <div className={styles.audienceCard}>
                <img
                  alt="illustration of school community with adults, children, a school building, and a green tree"
                  src={communityIcon}
                  style={{ maxWidth: '100%', height: '100px', width: 'auto', margin: '0 auto' }}
                  className="rounded"
                />
                <h4 className="font-heavy text-center mt-3">Solutions</h4>
                <span className="text-gray text-center font-heavy">Learn how to get Unyted in your school</span>
              </div>
            </Link>
          </div>
        </div>
      )}
    </Modal>
  );
};

export default AudienceSegmentModal;
